import type { RootState } from "@src/store/rootState";
import { selectedExperience } from "@src/store/slices/experiences";
import { isExperiencePriceTest } from "@src/store/slices/experiences/selectors/price/isPriceTest";
import { Experience } from "@src/store/slices/experiences/types";
import { getConfiguration } from "@src/store/slices/organization/selectors/getConfiguration";

export const isDuplicateProductsPriceTest = (state: RootState) => {
  const experience = selectedExperience(state);
  if (!experience) return false;

  return isExperienceDuplicateProductsPriceTest(experience)(state);
};

export const isExperienceDuplicateProductsPriceTest =
  (experience: Experience) => (state: RootState) => {
    const priceTest = isExperiencePriceTest(experience)(state);
    const duplicateProducts = getConfiguration<boolean>(
      "should_duplicate_products"
    )(state);
    return duplicateProducts && priceTest;
  };
